export const CalendarSettingsFormsFixture = {
  empty: 'empty',
  manyTaskTypes: 'many-task-types',
  mock: 'mock',
  senderUnavailable: 'sender-unavailable',
}

export const CALENDAR_SETTINGS_FORMS_FIXTURE_IDS = [
  CalendarSettingsFormsFixture.mock,
  CalendarSettingsFormsFixture.manyTaskTypes,
  CalendarSettingsFormsFixture.empty,
  CalendarSettingsFormsFixture.senderUnavailable,
]

export const CALENDAR_SETTINGS_FORMS_FIXTURES = [
  {
    id: CalendarSettingsFormsFixture.mock,
    qaName: 'calendarSettingsFormsMock',
    text: 'On the mock',
  },
  {
    id: CalendarSettingsFormsFixture.manyTaskTypes,
    qaName: 'calendarSettingsFormsManyTaskTypes',
    text: 'More than 25 task types',
  },
  {
    id: CalendarSettingsFormsFixture.empty,
    qaName: 'calendarSettingsFormsEmpty',
    text: 'No task types, no time zone, no mailbox',
  },
  {
    id: CalendarSettingsFormsFixture.senderUnavailable,
    qaName: 'calendarSettingsFormsSenderUnavailable',
    text: 'Saved mailbox no longer available',
  },
]
